/**
 * Loader Component
 * 
 * Simple loading spinner component for use in QueryBoundary
 */
export function Loader() {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-muted-foreground"></div>
    </div>
  );
}
